// extracted by css-extract-rspack-plugin
export default {"linksWrapper":"footer-fragment__FooterLinkList_linksWrapper__KhRd8"};